import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";



export const billing_expense_getByemptimesheetHV2 = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TIMESHEET_H_URL}` + `/gettimeaporv2/${id}`);
};


